import { Link } from 'react-router-dom';
import Metadata from '../components/Metadata';
import { services } from '../data/services';
import { getOptimizedImageUrl } from '../lib/utils';

export default function JegTilbyder() {
  return (
    <>
      <Metadata
        title="Jeg tilbyder - K. Pheiffer Construction"
        description="Se hvilke bygge- og renoveringsopgaver K. Pheiffer Construction tilbyder, og hvordan vi hjælper med kvalitetsløsninger."
      />

      {/* Page Header */}
      <section className="bg-slate-950 text-white py-16 sm:py-24 relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(16,185,129,0.05),transparent_40%)]" />
        <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <span className="text-xs font-bold uppercase tracking-widest text-emerald-400">
            Vores ydelser
          </span>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight mt-2">
            Det tilbyder vi
          </h1>
          <p className="mt-4 text-slate-400 text-base sm:text-lg max-w-2xl mx-auto">
            Vi udfører alt inden for tømrerfaget med stor præcision og stolthed. Læs mere om vores ydelser herunder.
          </p>
        </div>
      </section>

      {/* Services Sections */}
      <section className="py-16 sm:py-24 bg-white space-y-24 sm:space-y-32">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          {services.map((service, index) => {
            const isEven = index % 2 === 0;
            return (
              <div
                key={service.id}
                id={service.id}
                className={`grid grid-cols-1 lg:grid-cols-12 gap-12 items-center ${
                  index > 0 ? 'pt-24 sm:pt-32 border-t border-slate-100' : ''
                }`}
              >
                {/* Image Column */}
                <div className={`lg:col-span-5 ${isEven ? 'lg:order-1' : 'lg:order-2'}`}>
                  <div className="relative">
                    <div className="absolute -inset-4 rounded-2xl bg-slate-50 -z-10" />
                    <img
                      src={getOptimizedImageUrl(service.image, 800, 90)}
                      alt={service.title}
                      className="rounded-xl shadow-md w-full object-cover aspect-[4/3] sm:aspect-[3/2] lg:aspect-[4/3]"
                    />
                  </div>
                </div>

                {/* Content Column */}
                <div className={`lg:col-span-7 space-y-6 ${isEven ? 'lg:order-2' : 'lg:order-1'}`}>
                  <div className="flex items-center gap-3">
                    <div className="h-10 w-10 rounded-lg bg-slate-950 text-white flex items-center justify-center border border-slate-800">
                      <i className={`${service.icon} text-emerald-400`} />
                    </div>
                    <h2 className="text-2xl sm:text-3xl font-bold text-slate-900">
                      {service.title}
                    </h2>
                  </div>

                  <p className="text-slate-600 text-sm sm:text-base leading-relaxed">
                    {service.description}
                  </p>

                  {/* Benefits List */}
                  <div className="space-y-3 pt-2">
                    <h4 className="text-sm font-bold text-slate-900 uppercase tracking-wider">
                      Dine fordele:
                    </h4>
                    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      {service.benefits.map((benefit, bIdx) => (
                        <li key={bIdx} className="flex items-start gap-2 text-sm text-slate-600">
                          <i className="fa-regular fa-circle-check text-emerald-600 mt-0.5 flex-shrink-0" />
                          <span>{benefit}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* CTA Buttons */}
                  <div className="pt-4 flex flex-wrap gap-4">
                    <Link
                      to="/kontakt"
                      className="inline-flex items-center justify-center rounded bg-emerald-600 hover:bg-emerald-500 text-white px-5 py-3 text-sm font-semibold tracking-wide transition-all duration-200 hover:shadow-md hover:shadow-emerald-900/10 active:scale-95"
                    >
                      Få et tilbud på {service.title.toLowerCase()}
                      <i className="fa-regular fa-arrow-right ml-2" />
                    </Link>
                    <Link
                      to={`/jeg-tilbyder/${service.id}`}
                      className="inline-flex items-center justify-center rounded border border-slate-300 hover:border-slate-400 text-slate-700 hover:bg-slate-50 px-5 py-3 text-sm font-semibold tracking-wide transition-all duration-200"
                    >
                      Læs mere om ydelsen
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* Bottom Banner */}
      <section className="bg-slate-50 py-16 border-t border-slate-100">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <h3 className="text-xl sm:text-2xl font-bold text-slate-900">
            Har du en anden opgave i tankerne?
          </h3>
          <p className="mt-2 text-slate-500 text-sm sm:text-base max-w-xl mx-auto">
            Vi påtager os mange forskellige typer specialopgaver. Kontakt os for en uforpligtende snak om dine idéer.
          </p>
          <div className="mt-6">
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center rounded bg-slate-900 hover:bg-slate-800 text-white px-6 py-3 text-sm font-semibold tracking-wide transition-colors"
            >
              Kontakt os nu
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
